export const XS = 'XS';
export const M = 'M';
export const L = 'L';
export const XL = 'XL';
